import React from 'react'
import styled from 'styled-components'
import { SCHOOL_GRADES } from '@laputan/core'
import { SchoolHelper } from '@laputan/helpers'
import { SchoolDetailsSectionSubTitle } from '../School/SchoolDetailsSectionTitle'
import { STYLES } from '../../static/style'

const StyledSchoolFeeDetails = styled.div``

const SchoolFeesTableContainer = styled.div`
  width: 100%;
  overflow-x: auto;
`

const SchoolFeesTable = styled.table``

const CELL_PADDING = '.25rem .5rem'

const TableHeaderCell = styled.th`
  padding: ${CELL_PADDING};
  white-space: nowrap;
  background-color: ${STYLES.COLOR_WHITE};
  font-weight: ${STYLES.FONT_WEIGHT_NORMAL};
`

const TableHeaderStickyCell = styled(TableHeaderCell)`
  position: sticky;
  left: 0;
  font-weight: ${STYLES.FONT_WEIGHT_NORMAL};
`

const TableCell = styled.td`
  padding: ${CELL_PADDING};
`

interface ISchoolFeeDetailsProps {
  fee: object
  className?: string
}

const SchoolFeeDetails: React.FC<ISchoolFeeDetailsProps> = ({
  fee,
  className,
}) => {
  const { local = {}, international = {} } = fee
  const hasLocal = Object.keys(local).length > 0
  const hasInternational = Object.keys(international).length > 0
  const displayGrades = SCHOOL_GRADES.filter(
    ({ key }) => local[key] || international[key]
  )
  if (displayGrades.length === 0) {
    return null
  }
  return (
    <StyledSchoolFeeDetails className={className}>
      <SchoolDetailsSectionSubTitle>School Fees</SchoolDetailsSectionSubTitle>
      <SchoolFeesTableContainer
        onMouseDown={(ev) => ev.stopPropagation()}
        onTouchStart={(ev) => ev.stopPropagation()}
      >
        <SchoolFeesTable>
          <thead>
            <tr>
              <TableHeaderStickyCell>&nbsp;</TableHeaderStickyCell>
              {displayGrades.map(({ text }) => (
                <TableHeaderCell key={text}>{text}</TableHeaderCell>
              ))}
            </tr>
          </thead>
          <tbody>
            {hasLocal && (
              <tr>
                <TableHeaderStickyCell>Local</TableHeaderStickyCell>
                {displayGrades.map(({ key }) => (
                  <TableCell key={key}>
                    {SchoolHelper.currencyFormat(local[key])}
                  </TableCell>
                ))}
              </tr>
            )}
            {hasInternational && (
              <tr>
                <TableHeaderStickyCell>International</TableHeaderStickyCell>
                {displayGrades.map(({ key }) => (
                  <TableCell key={key}>
                    {SchoolHelper.currencyFormat(international[key])}
                  </TableCell>
                ))}
              </tr>
            )}
          </tbody>
        </SchoolFeesTable>
      </SchoolFeesTableContainer>
    </StyledSchoolFeeDetails>
  )
}

export { SchoolFeeDetails }
